var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('job-list',{attrs:{"filters":_vm.clientJobsFilter,"filterable":true,"show-left-menu":false,"go-to-add-on-click":false},on:{"on-add":_vm.onAdd}})}
var staticRenderFns = []

export { render, staticRenderFns }